import { MapsApi } from "@asd/customer-portal-api";
import { AxiosResponse } from "axios";

import AxiosConfigurations, { AxiosConfiguration } from "./AxiosConfiguration";

import { axiosInstance } from ".";

export class MapsService {
  static instance: MapsService;
  private mapsApi;
  private axiosConfiguration: AxiosConfiguration | undefined;

  constructor() {
    if (MapsService.instance) {
      return MapsService.instance;
    }

    this.mapsApi = new MapsApi(undefined, undefined, axiosInstance);
    const config = AxiosConfigurations.createAxiosConfiguration("MapsService", this.mapsApi);
    if (!config) {
      throw new Error("Failed to create AxiosConfiguration for MapsService");
    }
    this.axiosConfiguration = config;

    MapsService.instance = this;
  }

  public getPendingRequestCount() {
    return this.axiosConfiguration?.getPendingRequestCount();
  }

  public async getMapToken(options: object = {}) {
    if (!this.mapsApi) {
      throw new Error("mapsApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.mapsApi.getToken(options);
      return response;
    } catch {
      // do nothing
    }
  }
}

export default new MapsService();
